export const RegistracijaKompanijeResourcesEN: RegistracijaKompanijeResourcesBSInterface =
  {
    dupplicateError: "Addition failed, entered data is duplicated",
    izmjenaPoslovnice: {
      title: "Edit branch data",
      next: "Save",
      back: "Back",
      dialogSuccess: {
        title: "Success!",
        body: "You have successfully changed branch data!",
        buttonOk: "OK",
      },
      errorLoading: "Error during loading. Please contact the administrator.",
      errorUpdate: "Branch update failed. Please contact the administrator.",
    },
    izmjenaKompanije: {
      title: "Edit company data",
      next: "Save",
      back: "Back",
      dialogSuccess: {
        title: "Success!",
        body: "You have successfully changed company data!",
        buttonOk: "OK",
      },
      errorLoading: "Error during loading. Please contact the administrator.",
      errorUpdate: "Company update failed. Please contact the administrator.",
    },
    odabirKompanije: {
      title: "Companies",
      dropdownLabel: "Select company:",
      dropdownPlaceholder: "Select company",
      dropdownNoOptionsMessage: "No companies entered",
      addCompanyButton: "Add new company",
      editCompanyButton: "Edit company",
      next: "Select",
      back: "Back",
      errorLoading: "Error during loading. Please contact the administrator.",
    },
    odabirPoslovnice: {
      title: "Branches",
      dropdownLabel: "Select branch:",
      dropdownPlaceholder: "Select branch",
      dropdownNoOptionsMessage: "No branches entered",
      addCompanyButton: "Add new branch",
      next: "Edit",
      back: "Back",
      errorLoading: "Error during loading. Please contact the administrator.",
    },
    dodavanjeKompanije: {
      title: "Add company",
      formButton: "Save",
      next: "Forward",
      back: "Back",
      companyName: {
        label: "Company Name",
        name: "companyName",
        error: "You have not entered company name",
      },
      street: {
        label: "Street and number",
        name: "street",
        error: "You have not entered street",
      },
      city: {
        label: "City",
        name: "city",
        error: "You have not entered city",
      },
      zipCode: {
        label: "Postal code",
        name: "zipCode",
        error: "You have not entered postal code",
        validation: "Invalid number",
      },
      country: {
        label: "Country",
        name: "country",
        error: "You have not entered country",
      },
      email: {
        label: "E-mail",
        name: "email",
        error: "You have not entered e-mail",
        validation: "You have not entered a valid e-mail",
      },
      phone: {
        label: "Phone",
        name: "phone",
        error: "You have not entered phone",
        validation: "Invalid number",
      },
      idCompanyNumber: {
        label: "ID number",
        name: "idCompanyNumber",
        error: "You have not entered ID number",
        validation: "Invalid number",
      },
      vatCompanyNumber: {
        label: "VAT number",
        name: "vatCompanyNumber",
        error: "You have not entered VAT number",
        validation: "Invalid number",
      },
      contactPerson: {
        label: "Contact person",
        name: "contactPerson",
        error: "You have not entered contact person",
      },
      saleRepresentative: {
        label: "Sales representative",
        name: "saleRepresentative",
        error: "You have not entered sales representative",
      },
      salesPersonDropdown: {
        label: "Select sales agent (optional)",
        placeholder: "Select sales agent",
        noOptions: "No sales agents available",
      },
      chiefUsersDropdown: {
        label: "Select company chiefs (optional)",
        placeholder: "Select company chiefs",
        noOptions: "No users available",
      },
      managerUsersDropdown: {
        label: "Select branch managers (optional)",
        placeholder: "Select branch managers",
        noOptions: "No users available",
      },
      branchName: {
        label: "Branch name",
        name: "branchName",
        error: "You have not entered branch name",
      },
      dialogSuccess: {
        title: "Success!",
        body: "You have added the company to the database!",
        buttonOk: "OK",
      },
    },
    dodavanjePoslovnice: {
      title: "Add branch",
      type: "Object type",
      name: "objectType",
      error: "You have not selected a branch",
      options: [
        {
          value: "",
          label: "Please select object type",
        },
        {
          value: "Punionica meda",
          label: "Honey filling station",
        },
        {
          value: "Ugostiteljski objekat",
          label: "Catering facility",
        },
        {
          value: "Pekara",
          label: "Bakery",
        },
        {
          value: "Apoteka",
          label: "Pharmacy",
        },
        {
          value: "Hotel",
          label: "Hotel",
        },
      ],
      dialogSuccess: {
        title: "Success!",
        body: "You have added the branch to the database!",
        buttonOk: "OK",
      },
    },
  };

export interface RegistracijaKompanijeResourcesBSInterface {
  dupplicateError: string;
  izmjenaPoslovnice: {
    title: string;
    next: string;
    back: string;
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
    errorLoading: string;
    errorUpdate: string;
  };
  izmjenaKompanije: {
    title: string;
    next: string;
    back: string;
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
    errorLoading: string;
    errorUpdate: string;
  };
  odabirKompanije: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    editCompanyButton: string;
    errorLoading: string;
    next: string;
    back: string;
  };
  odabirPoslovnice: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  dodavanjeKompanije: {
    title: string;
    formButton: string;
    next: string;
    back: string;
    companyName: {
      label: string;
      name: string;
      error: string;
    };
    street: {
      label: string;
      name: string;
      error: string;
    };
    city: {
      label: string;
      name: string;
      error: string;
    };
    zipCode: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    country: {
      label: string;
      name: string;
      error: string;
    };
    email: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    phone: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    idCompanyNumber: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    vatCompanyNumber: {
      label: string;
      name: string;
      error: string;
      validation: string;
    };
    contactPerson: {
      label: string;
      name: string;
      error: string;
    };
    saleRepresentative: {
      label: string;
      name: string;
      error: string;
    };
    salesPersonDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    chiefUsersDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    managerUsersDropdown: {
      label: string;
      placeholder: string;
      noOptions: string;
    };
    branchName: {
      label: string;
      name: string;
      error: string;
    };
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
  };
  dodavanjePoslovnice: {
    title: string;
    type: string;
    name: string;
    error: string;
    options: {
      value: string;
      label: string;
    }[];
    dialogSuccess: {
      title: string;
      body: string;
      buttonOk: string;
    };
  };
}
